import { render, staticRenderFns } from "./AsideMenuItem.vue?vue&type=template&id=6fed252c&"
import script from "./AsideMenuItem.vue?vue&type=script&lang=js&"
export * from "./AsideMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fed252c')) {
      api.createRecord('6fed252c', component.options)
    } else {
      api.reload('6fed252c', component.options)
    }
    module.hot.accept("./AsideMenuItem.vue?vue&type=template&id=6fed252c&", function () {
      api.rerender('6fed252c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AsideMenuItem.vue"
export default component.exports